export default "__VITE_ASSET__a6569cf1__"